module.exports = __webpack_public_path__ + "static/media/Linkedin.666ed8f9.svg";